import { useChartDisplay } from '../../../../ui-components/data-viz-ui/charts/common/common-chart-utils/use-chart-display-reducer';
import { ComponentStateManager } from '../../../common/types';
import { MetricTableVizExternalProps } from '../../types';
import { MetricTableViewActions, MetricTableViewState } from './types';

export const useMetricTableViewStateManager = (
  externalProps: MetricTableVizExternalProps,
  persistenceKey: string
): ComponentStateManager<MetricTableViewState, MetricTableViewActions> => {
  const { displayState, displayActions } = useChartDisplay(
    {
      enablePercentage: false,
      enableStack: false,
      enableLabels: false,
      enableLegend: false,
      enableSortOrder: false,
      enableTableView: false,
      globalDisplayState: externalProps.displayGlobalState,
    },
    persistenceKey
  );

  return {
    state: {
      displayState,
    },
    actions: {
      displayActions: {
        onSelectSortOrder: displayActions.onSelectSortOrder,
        onClickTableView: displayActions.onClickTableView,
      },
    },
  };
};
